import { Flex, Drawer, Button, Typography } from 'antd';
import { spacing, colors, fontSize, primitiveColors } from './../../../theming';
import classes from './MobileMenu.module.scss';
import { useTranslation } from 'react-i18next';
import { LanguageSelect } from '../languageSelect/languageSelect';
import { useMedia } from '../../../hooks/useMediaQuery';
import { NavigationLinks } from '../navigationLinks/navigationLinks';
import { useNavigate } from 'react-router-dom';
import icon from '../../styles/Icon.module.scss';
import { useImpersonation } from '../../../hooks/useImpersonation';
import { StopImpersonationButton } from '../../../components/impersonation/StopImpersonationButton';

const MobileMenu = ({ isMobileMenuOpen, closeMobileMenu, headerHeight, logout }) => {
    const { i18n, t } = useTranslation(['general', 'navigationLinks', 'sidebar']);
    const { isSmallDevice, isExtraSmallDevice } = useMedia();

    const navigate = useNavigate();
    // in an impersonation tab "Log out" stops the impersonation instead
    const { isImpersonating } = useImpersonation();

    const accountButtonStyle = {
        color: primitiveColors.text,
        backgroundColor: 'transparent',
        border: `1px solid ${primitiveColors.text}`,
        width: isExtraSmallDevice ? '100%' : 500,
        height: isExtraSmallDevice ? 56 : 64,
    };
    const exitIcon = (
        <i className={`fi fi-rr-exit ${icon.md}`} style={{ marginTop: 0, color: primitiveColors.text }}></i>
    );

    return (
        <Drawer
            open={isMobileMenuOpen}
            placement="top"
            closable={false}
            styles={{
                wrapper: {
                    height: 260,
                    // below the impersonation bar too, when there is one
                    top: `calc(${headerHeight} + var(--impersonation-bar-height, 0px))`,
                    width: '100vw',
                },
                body: {
                    height: '100%',
                    padding: isSmallDevice
                        ? `${spacing[5]} 28px ${spacing[11]}`
                        : `${spacing[3]} ${spacing[4]} ${spacing[8]}`,
                    backgroundColor: colors.white,
                    overflow: 'auto',
                },
                content: {
                    borderRadius: 0,
                },
                mask: {
                    top: `calc(${headerHeight} + var(--impersonation-bar-height, 0px))`,
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    backdropFilter: 'blur(4px)',
                },
            }}
            className={`${classes.drawerWrapper} ${isMobileMenuOpen ? classes.opening : classes.closing}`}
            maskClassName={`${classes.drawerMask} ${isMobileMenuOpen ? classes.opening : classes.closing}`}
        >
            <Flex vertical align="start" justify="flex-start" gap={spacing[5]} style={{ height: '100%' }}>
                <Flex justify="space-between" align="center" style={{ width: '100%' }}>
                    <Typography.Text style={{ fontWeight: 500, fontSize: fontSize.sm, color: primitiveColors.text }}>
                        {t('general:language')}
                    </Typography.Text>

                    <LanguageSelect i18n={i18n} />
                </Flex>

                {/* <NavigationLinks isMobile={true} t={t} /> */}

                <Flex gap={spacing[3]} vertical align="center" style={{ width: '100%' }}>
                    <Button
                        className={classes['check-vin']}
                        onClick={() => {
                            closeMobileMenu();
                            navigate('/');
                        }}
                        style={{ width: isExtraSmallDevice ? '100%' : 500, height: isExtraSmallDevice ? 56 : 64 }}
                    >
                        {`${t('general:check')} VIN`}
                    </Button>

                    {isImpersonating ? (
                        <StopImpersonationButton
                            className={classes.buttonMyAccount}
                            style={accountButtonStyle}
                            renderLabel={label => (
                                <>
                                    {exitIcon}
                                    {label}
                                </>
                            )}
                        />
                    ) : (
                        <Button className={classes.buttonMyAccount} style={accountButtonStyle} onClick={logout}>
                            {exitIcon}
                            {t('sidebar:logout')}
                        </Button>
                    )}
                </Flex>
            </Flex>
        </Drawer>
    );
};

export default MobileMenu;
